// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedAnterior_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14.892 17.472L14.06 14.752H9.9L9.068 17.472H6.46L10.492 6H13.452L17.5 17.472H14.892ZM13.484 12.72L12.652 10.064C12.5987 9.88267 12.5293 9.65333 12.444 9.376C12.3587 9.09867 12.2733 8.816 12.188 8.528C12.1027 8.24 12.0333 7.98933 11.98 7.776C11.9267 7.98933 11.852 8.256 11.756 8.576C11.6707 8.88533 11.5853 9.184 11.5 9.472C11.4253 9.74933 11.3667 9.94667 11.324 10.064L10.508 12.72H13.484Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0V24H24V0H0ZM22 2H2V22H22V2Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedAnterior is a generated icon component.
 */
let IconMedAnterior = IconMedAnterior_1 = class IconMedAnterior extends IconBaseElement {
    render() {
        return html `${IconMedAnterior_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedAnterior.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedAnterior = IconMedAnterior_1 = __decorate([
    customElement('zui-icon-med-anterior')
], IconMedAnterior);
export { IconMedAnterior };
